import { canProvisionFreeDashTeam } from "@mirage/service-provisioning";
import { useDoOnceOnMount } from "@mirage/shared/hooks/useDoOnceOnMount";
import { useState } from "react";

export const useCanProvisionFreeDashTeam = () => {
  const [canProvisionDashFreemiumTeam, setCanProvisionDashFreemiumTeam] =
    useState(false);
  const [loading, setLoading] = useState(true);

  useDoOnceOnMount(async () => {
    const isEligibleForFreeDashTeam = await canProvisionFreeDashTeam();
    setCanProvisionDashFreemiumTeam(isEligibleForFreeDashTeam);
    setLoading(false);
  });

  return { canProvisionDashFreemiumTeam, loading };
};
